import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getBackgroundImageOptions,
  getBackgroundSizeOptions,
} from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import { v4 as uuidv4 } from "uuid";

import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "stack",
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        flexDirection: {
          type: "select",
          value: defaultStyles.flexDirection,
        },
        alignItems: {
          type: "select",
          value: defaultStyles.alignItems,
        },
        justifyContent: {
          type: "select",
          value: defaultStyles.justifyContent,
        },
        flexWrap: {
          type: "select",
          value: defaultStyles.flexWrap,
        },
        gap: {
          type: "slider",
          value: defaultStyles.gap,
        },
        backgroundColor: {
          type: "color",
          value: defaultStyles.backgroundColor,
        },
        backgroundImage: getBackgroundImageOptions(),
        backgroundSize: getBackgroundSizeOptions({
          defaultValue: defaultStyles.backgroundSize,
        }),
        borderWidth: {
          type: "number",
          value: defaultStyles.borderWidth,
        },
        borderColor: {
          type: "color",
          value: defaultStyles.borderColor,
        },
        borderRadius: {
          type: "border-radius",
          value: defaultStyles.borderRadius,
        },
        borderStyle: {
          type: "select",
          value: defaultStyles.borderStyle,
        },
        sizing: {
          type: "sizing",
          value: defaultStyles.sizing,
        },
        margin: {
          type: "margin",
          value: defaultStyles.margin,
        },
        padding: {
          type: "padding",
          value: defaultStyles.padding,
        },
      },
    },
  },
};
